import React from 'react'
import Url from 'url-parse'

type ProviderOption = 'vimeo' | 'youtube' | 'appendee'

type ProcessUrlFn = (string) => string

interface ProviderConfig {
    provider: ProviderOption
    url: string
}

const setSearchParam = (url: string, key: string, value: string) => {
    const urlConstructor = new Url(url, true)
    urlConstructor.query[key] = value
    return urlConstructor.toString()
}

const providerToUrlProcessor: Record<ProviderOption, ProcessUrlFn> = {
    vimeo: (url: string) => setSearchParam(url, 'autoplay', '1'),
    youtube: (url: string) => setSearchParam(url, 'autoplay', '1'),
    appendee: (url: string) => url,
}

const PROVIDER_CONFIG: ProviderConfig[] = [
    {
        provider: 'vimeo',
        url: 'https://player.vimeo.com/',
    },
    {
        provider: 'youtube',
        url: 'https://www.youtube.com/',
    },
    {
        provider: 'youtube',
        url: 'https://youtu.be/',
    },
    {
        provider: 'appendee',
        url: 'https://cdn.elevent.ly/',
    },
    {
        provider: 'appendee',
        url: 'https://cdn.appendee.com/',
    },
]

const getProviderConfig = (streamUrl = ''): ProviderConfig | undefined => (
    PROVIDER_CONFIG.find(
        ({ url }) => streamUrl.startsWith(url)
    )
)

const getIsValidStreamUrl = (streamUrl: string) => !!getProviderConfig(streamUrl)

const processUrl = (streamUrl: string) => {
    const config = getProviderConfig(streamUrl)
    if (!config) { return streamUrl }
    return providerToUrlProcessor[config.provider](streamUrl)
}

const urlOptions = PROVIDER_CONFIG.map(({ url }) => url)

interface EmbeddedVideoProps {
    width?: number | string;
    height?: number | string;
    url?: string;
}

const DebugMessage = ({ url }: { url: string }) => (
    <div style={{ background: 'black', color: 'white' }}>
        {url}
        {' '}
        is not a valid
        lifestream. Choose one of:
        {' '}
        {urlOptions.join(', ')}
    </div>
)

const EmbeddedVideo = ({ url, width = '100%', height = '100%' }: EmbeddedVideoProps) => {
    const isValidStreamUrl = getIsValidStreamUrl(url)

    if (!isValidStreamUrl) {
        return <DebugMessage url={url} />
    }

    return (
        <iframe
            src={processUrl(url)}
            title="stream"
            width={width}
            height={height}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
        />
    )
}

export default EmbeddedVideo
